import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import useConfiguracion from '../../hooks/useConfiguracion';
import { RoutesPanel } from '../../Security/ProtectedRoute';
import CampaignLoginPanel from '../../components/campaign/CampaignLoginPanel';
import '../../styles/Panel.css';

/**
 * Login del personal municipal (HU-003, rediseño fiel a
 * design_handoff_reportes_ciudadanos sección 7.1) — tarjeta partida: panel
 * izquierdo oscuro con el logo de la instancia (marca blanca, HU-005) y
 * panel derecho con el formulario. El aviso de error es inline (ámbar),
 * nunca un modal — un login fallido no es una interrupción, es información
 * de la propia pantalla.
 */
const PanelLogin = () => {
  const [documento, setDocumento] = useState('');
  const [password, setPassword] = useState('');
  const { login, loading, error } = useAuth();
  const { configuracion } = useConfiguracion();
  const navigate = useNavigate();

  const handleSubmit = async (evento) => {
    evento.preventDefault();
    const resultado = await login({ usu_chDoc: documento, password });
    if (resultado.success) {
      navigate(RoutesPanel.INICIO, { replace: true });
    }
  };

  return (
    <div className="panel-login-fondo">
      <div className={`panel-login-panel-marca ${configuracion.banner ? 'panel-login-panel-marca-campana' : ''}`}>
        {configuracion.banner ? (
          <CampaignLoginPanel configuracion={configuracion} />
        ) : (
          <>
            <div className="panel-login-logo">
              {configuracion.logo
                ? <img src={configuracion.logo} alt={configuracion.nombre_entidad} />
                : <span>{configuracion.nombre_entidad?.[0] || 'C'}</span>}
            </div>
            <div>
              <h1 className="panel-login-titulo-marca">Consola de operaciones</h1>
              <p className="panel-login-subtitulo-marca">Control interno.</p>
            </div>
          </>
        )}
      </div>

      <div className="panel-login-panel-form">
        <form onSubmit={handleSubmit}>
          <h2 className="panel-login-titulo">Iniciar sesión</h2>
          <p className="panel-login-subtitulo">Documento y contraseña institucional.</p>

          <label className="panel-label" htmlFor="panel-login-doc">Documento</label>
          <input
            id="panel-login-doc"
            type="text"
            className="panel-input"
            value={documento}
            onChange={(evento) => setDocumento(evento.target.value)}
            autoFocus
            required
          />

          <label className="panel-label" htmlFor="panel-login-pass">Contraseña</label>
          <input
            id="panel-login-pass"
            type="password"
            className="panel-input"
            value={password}
            onChange={(evento) => setPassword(evento.target.value)}
            required
          />

          {error && (
            <div className="panel-login-aviso">
              <span className="panel-login-aviso-punto"></span>
              <span>{error}</span>
            </div>
          )}

          <button type="submit" className="panel-boton-primario" disabled={loading}>
            {loading ? 'Ingresando…' : 'Entrar al panel'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PanelLogin;
